import { type Control, Controller } from 'react-hook-form';
import { Accordion, AccordionDetails, AccordionSummary, FormControl, FormHelperText, Stack, Typography } from '@mui/material';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import PhotoLibraryIcon from '@mui/icons-material/PhotoLibrary';

import { type EditAuditFormBackgroundData } from '#apps/client-web/pages/audit-form-background/types';
import { getFormErrorAttributes } from '#apps/client-web/app/helpers/react-hook-form';
import { FileInput } from '#apps/client-web/features/file-storage/components/file-input/file-input';

import { DeleteConfirmationDialog } from '#packages/web/layouts/dialog/templates/delete-confirmation';
import { useDialog } from '#packages/web/hooks/use-dialog';

export type BuildingAndSystemsFieldsProps = {
  control: Control<EditAuditFormBackgroundData>;
  disableForm: boolean;
};

export const BuildingAndSystemsFields = ({ control, disableForm }: BuildingAndSystemsFieldsProps) => {
  const deleteAttachmentDialog = useDialog<{ proceed: () => void }>();

  return (
    <Accordion variant="outlined">
      <AccordionSummary expandIcon={<ExpandMoreIcon />}>
        <Stack direction="row" alignItems="center" spacing={1}>
          <PhotoLibraryIcon fontSize="small" />
          <Typography variant="body1">Building and Systems</Typography>
        </Stack>
      </AccordionSummary>
      <AccordionDetails>
        <Controller
          control={control}
          name="buildingAndSystems.attachments"
          disabled={disableForm}
          render={({ field, fieldState }) => (
            <FormControl fullWidth {...getFormErrorAttributes(fieldState.error)}>
              <FileInput
                {...field}
                label="Attachments"
                onRemoveRequest={(_, proceed) => deleteAttachmentDialog.open({ proceed })}
                {...getFormErrorAttributes(fieldState.error)}
              />
              <FormHelperText>{fieldState.error?.message}</FormHelperText>
            </FormControl>
          )}
        />
      </AccordionDetails>

      <DeleteConfirmationDialog
        open={deleteAttachmentDialog.isOpen}
        dialogTitle="Remove Attachment"
        confirmButtonLabel="Remove"
        onConfirm={() => {
          deleteAttachmentDialog.data?.proceed();
          deleteAttachmentDialog.close();
        }}
        onCancel={() => deleteAttachmentDialog.close()}
      />
    </Accordion>
  );
};
